// this is an autogenerated file from App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/Connection/Content/ProviderCount/Content/Content/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_ConnectApps_App_Content_Connections_Content_Connection_Content_ProviderCount_Content_Content(
  $connection_id: uuid!
  $objects: [apps_connection_providers_insert_input!]!
) {
  delete_apps_connection_providers(
    where: { connection_id: { _eq: $connection_id } }
  ) {
    affected_rows
  }

  insert_apps_connection_providers(
    objects: $objects
    on_conflict: { constraint: connection_providers_pkey, update_columns: [] }
  ) {
    affected_rows
  }
}

`